// Ô "Giữ cửa sổ bot luôn hiện" trong hộp Sửa bot (06/10/2026 — src/shared/giu-cua-so.ts, đi cùng BotPolicy.nhip.giuCuaSoHien): tách khỏi bots.ts để không phình tệp đó.
// "Theo máy bot" = Boss không đặt (bot theo công tắc trong Cài đặt plugin, mặc định TẮT); "Luôn giữ hiện" = cửa sổ bị thu nhỏ thì khôi phục + hỏi 2 lần; "Cho thu nhỏ tự do" = như trước.
import { h } from "../dom";

export interface TruongGiuCuaSo {
  /** Nhãn + ô chọn, để đặt vào hộp Sửa bot. */
  nhan: HTMLElement;
  o: HTMLSelectElement;
  /** Giá trị cho chuanHoaNhipBoss: null (theo máy) | true | false. */
  doc(): boolean | null;
}

export function truongGiuCuaSo(hienTai: boolean | undefined): TruongGiuCuaSo {
  const o = h("select", {
    title: "Cửa sổ trình duyệt của bot bị thu nhỏ thì tab không được vẽ: Xem trực tiếp không có hình, bot dễ bị trình duyệt làm chậm/ngủ, điều khiển từ xa không chạy. Trình duyệt không cho chặn trước việc thu nhỏ, nên khi cửa sổ vừa thu nhỏ, plugin khôi phục ngay rồi hỏi 2 lần (người ngồi máy xác nhận cả hai mới được thu nhỏ). 'Theo máy bot' = theo công tắc trong Cài đặt plugin (mặc định tắt).",
    "data-testid": "edit-giu-cua-so",
  },
    h("option", { value: "" }, "Theo máy bot"), h("option", { value: "bat" }, "Luôn giữ cửa sổ hiện (hỏi 2 lần trước khi thu nhỏ)"), h("option", { value: "tat" }, "Cho thu nhỏ tự do")) as HTMLSelectElement;
  o.value = hienTai === undefined ? "" : hienTai ? "bat" : "tat";
  const nhan = h("label", { class: "f" }, h("span", {}, "Cửa sổ bot bị thu nhỏ"), o);
  return { nhan, o, doc: () => (o.value === "" ? null : o.value === "bat") };
}
